// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-history-modal .status-history-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-right: 8px;
  min-width: 0;
}
.status-history-modal .status-history-modal__title-block {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.status-history-modal .status-history-modal__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #00a896;
  color: #fff;
  flex-shrink: 0;
}
.status-history-modal .status-history-modal__title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--m-text, #1a2236);
}
.status-history-modal .status-history-modal__code {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 600;
  color: var(--m-text-light, #7a8499);
}
.status-history-modal .status-history-modal__total {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 8px;
  background: var(--m-card-background-color, #fff);
  color: #00a896;
  flex-shrink: 0;
}
.status-history-modal .status-history-modal__total strong {
  display: block;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.1;
  color: var(--m-text, #1a2236);
}
.status-history-modal .status-history-modal__total-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--m-text-light, #7a8499);
}
.status-history-modal .status-history-modal__empty {
  padding: 28px 8px;
  text-align: center;
  font-size: 13px;
  color: var(--m-text-light, #7a8499);
}
.status-history-modal .status-history-modal__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.status-history-modal .status-history-modal__more {
  margin-top: 4px;
  padding: 8px 12px;
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 8px;
  background: var(--m-card-background-color, #fff);
  color: var(--m-text, #1a2236);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.status-history-modal .status-history-modal__more:hover:not(:disabled) {
  border-color: rgba(0, 201, 183, 0.45);
  color: #00a896;
}
.status-history-modal .status-history-modal__more:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.status-history-card {
  position: relative;
  padding: 12px 14px 12px 18px;
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 10px;
  background: var(--m-card-background-color, #fff);
  overflow: hidden;
}
.status-history-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: #c62828;
}
.status-history-card.online::before {
  background: #00a896;
}
.status-history-card__top, .status-history-card__bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.status-history-card__bottom {
  margin-top: 10px;
}
.status-history-card__badge {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
}
.status-history-card__badge.online {
  background: #e6f9f6;
  color: #00a896;
}
.status-history-card__badge.offline {
  background: #fdecea;
  color: #c62828;
}
.status-history-card__info {
  display: inline-flex;
  color: #98a2b3;
  flex-shrink: 0;
}
.status-history-card__time {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--m-text, #1a2236);
}
.status-history-card__duration {
  font-size: 12px;
  font-weight: 600;
  color: var(--m-text-light, #7a8499);
  text-align: right;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/MachineMonitor/modals/StatusHistoryModal.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AADJ;AAIE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAFJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;AAHJ;AAME;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAJJ;AAOE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gDAAA;EACA,cAAA;EACA,cAAA;AALJ;AAOI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;AALN;AASE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mCAAA;AAPJ;AAUE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;AARJ;AAWE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AATJ;AAYE;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gDAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAVJ;AAYI;EACE,qCAAA;EACA,cAAA;AAVN;AAaI;EACE,YAAA;EACA,mBAAA;AAXN;;AAgBA;EACE,kBAAA;EACA,4BAAA;EACA,0CAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;AAbF;AAeE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,mBAAA;AAdJ;AAiBE;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAhBJ;AAmBE;EACE,gBAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAlBJ;AAoBI;EACE,mBAAA;EACA,cAAA;AAlBN;AAqBI;EACE,mBAAA;EACA,cAAA;AAnBN;AAuBE;EACE,oBAAA;EACA,cAAA;EACA,cAAA;AArBJ;AAwBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;AAvBJ","sourcesContent":[".status-history-modal {\n  .status-history-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding-right: 8px;\n    min-width: 0;\n  }\n\n  .status-history-modal__title-block {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n  }\n\n  .status-history-modal__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    background: #00a896;\n    color: #fff;\n    flex-shrink: 0;\n  }\n\n  .status-history-modal__title {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.2;\n    color: var(--m-text, #1a2236);\n  }\n\n  .status-history-modal__code {\n    margin-top: 2px;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--m-text-light, #7a8499);\n  }\n\n  .status-history-modal__total {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    border: 1px solid var(--m-border, #d0d5dd);\n    border-radius: 8px;\n    background: var(--m-card-background-color, #fff);\n    color: #00a896;\n    flex-shrink: 0;\n\n    strong {\n      display: block;\n      font-size: 18px;\n      font-weight: 800;\n      line-height: 1.1;\n      color: var(--m-text, #1a2236);\n    }\n  }\n\n  .status-history-modal__total-label {\n    display: block;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    color: var(--m-text-light, #7a8499);\n  }\n\n  .status-history-modal__empty {\n    padding: 28px 8px;\n    text-align: center;\n    font-size: 13px;\n    color: var(--m-text-light, #7a8499);\n  }\n\n  .status-history-modal__list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .status-history-modal__more {\n    margin-top: 4px;\n    padding: 8px 12px;\n    border: 1px solid var(--m-border, #d0d5dd);\n    border-radius: 8px;\n    background: var(--m-card-background-color, #fff);\n    color: var(--m-text, #1a2236);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n\n    &:hover:not(:disabled) {\n      border-color: rgba(0, 201, 183, 0.45);\n      color: #00a896;\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.status-history-card {\n  position: relative;\n  padding: 12px 14px 12px 18px;\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: 10px;\n  background: var(--m-card-background-color, #fff);\n  overflow: hidden;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 5px;\n    background: #c62828;\n  }\n\n  &.online::before {\n    background: #00a896;\n  }\n\n  &__top,\n  &__bottom {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  &__bottom {\n    margin-top: 10px;\n  }\n\n  &__badge {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 3px 10px;\n    border-radius: 20px;\n\n    &.online {\n      background: #e6f9f6;\n      color: #00a896;\n    }\n\n    &.offline {\n      background: #fdecea;\n      color: #c62828;\n    }\n  }\n\n  &__info {\n    display: inline-flex;\n    color: #98a2b3;\n    flex-shrink: 0;\n  }\n\n  &__time {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--m-text, #1a2236);\n  }\n\n  &__duration {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--m-text-light, #7a8499);\n    text-align: right;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
